import {EntityHistory} from "./EntityHistory";
import ResidencyUses from "./enums/ResidencyUses.js";
import {findEntityById, toFullEntityResult} from "./helpers/toFullEntityResult";
import IHolder from "./interfaces/IHolder";
import {ResidencyId} from "./nominalTypes/ResidencyId";
import {ZoneId} from "./nominalTypes/ZoneId";
import {FullEntityRelation} from "./types/EntityRelation";
import {PermitEntityResult, PermitFullEntityResult} from "./types/PermitEntityResult";
import {ResidencyResult} from "./types/ResidencyResult";

function createEmptyResidency(residencyId: ResidencyId): ResidencyResult {
	return {
		id: residencyId,
		uses: ResidencyUses.None,
		address: {street: residencyId, streetNumber: "—"},
		zoneId: "" as ZoneId,
		customData: [],
		attachments: []
	}
}

class Residencies {
	static get(holder: IHolder, id: ResidencyId): ResidencyResult {
		return findEntityById(holder.residencies, id, createEmptyResidency);
	}

	static getAll(holder: IHolder, ids: ResidencyId[]): ResidencyResult[] {
		return ids.map(id => this.get(holder, id));
	}

	static getChanged(holder: IHolder, residency: PermitEntityResult<ResidencyId>[]): FullEntityRelation<ResidencyId, ResidencyResult> | undefined {
		const c = EntityHistory.changed(residency);
		if (!c) {
			return;
		}

		const {original, changed} = c;
		return {
			original: toFullEntityResult(holder.residencies, original, createEmptyResidency),
			changed: changed && toFullEntityResult(holder.residencies, changed, createEmptyResidency)
		};
	}

	static getValid(holder: IHolder, residency: PermitEntityResult<ResidencyId>[]): PermitFullEntityResult<ResidencyId, ResidencyResult> | undefined {
		const e = EntityHistory.approvedOrDefault(residency);
		if (e == null) {
			return;
		}
		return toFullEntityResult(holder.residencies, e, createEmptyResidency);
	}
}

export {Residencies};
